var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBxMoney(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 37,
    viewBox: "0 0 36 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.5 6.28418H4.5C3.6705 6.28418 3 6.95468 3 7.78418V28.7842C3 29.6137 3.6705 30.2842 4.5 30.2842H31.5C32.3295 30.2842 33 29.6137 33 28.7842V7.78418C33 6.95468 32.3295 6.28418 31.5 6.28418ZM30 22.7842C27.5145 22.7842 25.5 24.7987 25.5 27.2842H10.5C10.5 24.7987 8.4855 22.7842 6 22.7842V13.7842C8.4855 13.7842 10.5 11.7697 10.5 9.28418H25.5C25.5 11.7697 27.5145 13.7842 30 13.7842V22.7842Z",
    fill: "#495057"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 12.2842C14.691 12.2842 12 14.9752 12 18.2842C12 21.5932 14.691 24.2842 18 24.2842C21.309 24.2842 24 21.5932 24 18.2842C24 14.9752 21.309 12.2842 18 12.2842ZM18 21.2842C16.3455 21.2842 15 19.9387 15 18.2842C15 16.6297 16.3455 15.2842 18 15.2842C19.6545 15.2842 21 16.6297 21 18.2842C21 19.9387 19.6545 21.2842 18 21.2842Z",
    fill: "#495057"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBxMoney);
export default __webpack_public_path__ + "static/media/bx-money.070dbdf7.svg";
export { ForwardRef as ReactComponent };